import * as tslib_1 from "tslib";
/**
 * Serializes asynchronous sections: each dispatched function runs only after the previous one has
 * settled, turning overlapping async calls into an ordered queue.
 *
 * Adapted from https://spin.atomicobject.com/2018/09/10/javascript-concurrency/
 */
var Lock = /** @class */ (function () {
    function Lock() {
        this.mutex = Promise.resolve();
    }
    Lock.prototype.lock = function () {
        var begin = function () { return undefined; };
        this.mutex = this.mutex.then(function () { return new Promise(begin); });
        return new Promise(function (res) {
            begin = res;
        });
    };
    Lock.prototype.dispatch = function (fn) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var unlock;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lock()];
                    case 1:
                        unlock = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, fn()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        unlock();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return Lock;
}());
export { Lock };
